import React from 'react'
import TableComponent from '../customtable/customtable'
import { Box, Typography } from '@mui/material'
import '../../pages/dashboard/dashboard.css'
import { useNavigate } from 'react-router-dom'

const TableWrapper = ({
  rows,
  columns,
  title,
  isShowFiveRecords = false,
  view,
  to,
  totalParts,
  totalTasks,
  showTotalTasks = true,
  showTotalParts = true,
  isBottomTitle = false
}) => {
  const navigate = useNavigate() // Initialize navigate

  const handleNavigation = () => {
    navigate(to.path, { state: to.state }) // Navigate to the specified route
  }
  return (
    <React.Fragment>
      <Box className="parent-table-wrapper">
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography className="wrapper-title">{title}</Typography>
          <div style={{ display: 'flex' }}>
            <Box className="stats-container">
              {/* Display Total Parts */}
              {
                !isBottomTitle && (
                  <>
                    <Box className="stats-box">
                      <span>Total Parts - {totalParts || '0'}</span>
                    </Box>
                    <Box className="stats-box">
                      <span>Total Tasks - {totalTasks || '0'}</span>
                    </Box>
                  </>
                )
              }
            </Box>
            <div
              className="wrapper-view"
              onClick={handleNavigation} // Use navigate on click
            >
              {view}
            </div>
          </div>
        </Box>
        {isBottomTitle && (
          <Box className="stats-container-box">
            {showTotalParts && (
              <Box className="stats-box">
                <span>Total Parts - {totalParts || '0'}</span>
              </Box>
            )}
            {showTotalTasks && (
              <Box className="stats-box">
                <span>Total Tasks - {totalTasks || '0'}</span>
              </Box>
            )}
          </Box>
        )}
        <TableComponent
          rows={rows}
          isShowFiveRecords={isShowFiveRecords}
          columns={columns}
          hidePagination={true}
        />
      </Box>
    </React.Fragment>
  )
}

export default TableWrapper
